import { useInfiniteQuery } from 'react-query';
import {
  getCastRelationships,
  type CastRelationshipsResponse
} from '../../services/castRelationshipService';

export function useGetCastRelationships({
  perPage,
  enabled = true
}: {
  perPage: number;
  enabled?: boolean;
}) {
  const queryResult = useInfiniteQuery<CastRelationshipsResponse>(
    ['castRelationships', perPage],
    ({ pageParam = 1 }) => getCastRelationships({ page: pageParam, perPage }),
    {
      enabled,
      getNextPageParam: (lastPage) => {
        if (lastPage?.meta?.pagination?.currentPage < lastPage?.meta?.pagination?.totalPages) {
          return lastPage?.meta?.pagination?.currentPage + 1;
        }
        return undefined;
      }
    }
  );

  return {
    ...queryResult,
    castRelationships: queryResult.data?.pages.flatMap((page) => page.castRelationships) ?? []
  };
}
